import React from 'react';
import type { SVGPropsWithClassName } from './types';
import { colors } from '@/styles';

export const VideoLibrary2 = ({
  className = '',
  size = 14,
  title = 'Video Library',
  fill = colors.kermit,
}: SVGPropsWithClassName) => {
  const height = Number(size) * 2.85;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      height={height}
      viewBox="0 0 20 16"
    >
      {Boolean(title) && <title>{title}</title>}
      <path
        d={
          'M18.37,16H5a1.67,1.67,0,0,1-1.67-1.67V4.89A1.68,1.68,0,0,1,5,3.22H18.37A1.67,1.67,0,0,' +
          '1,20,4.89v9.44A1.66,1.66,0,0,1,18.37,16ZM5,4.85a0,0,0,0,0,0,0h0v9.44a0,0,0,0,0,0,.05H1' +
          '8.37a0,0,0,0,0,0-.05h0V4.89a0,0,0,0,0,0,0H5Z'
        }
        fill={fill}
      />
      <path
        d={
          'M.81,11.92A.81.81,0,0,1,0,11.11H0V1.67A1.67,1.67,0,0,1,1.67,0H15.09a.81.81,0,1,1,0,1.6' +
          '2H1.67a0,0,0,0,0,0,0h0v9.44a.81.81,0,0,1-.81.81Z'
        }
        fill={fill}
      />
      <path
        d={
          'M14.21,9.89a.2.2,0,0,1-.09.09l-3.6,2.15a.26.26,0,0,1-.35-.1h0a.28.28,0,0,1,0-.13V7.6a.' +
          '26.26,0,0,1,.26-.26h0a.31.31,0,0,1,.13,0l3.6,2.15A.27.27,0,0,1,14.21,9.89Z'
        }
        fill={fill}
      />
    </svg>
  );
};
